import { render } from "./HousesDesignsGrid.vue?vue&type=template&id=6745eaa2&scoped=true&ts=true&lang=pug"
import script from "./HousesDesignsGrid.vue?vue&type=script&lang=ts&setup=true"
export * from "./HousesDesignsGrid.vue?vue&type=script&lang=ts&setup=true"

import "./HousesDesignsGrid.vue?vue&type=style&index=0&id=6745eaa2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6745eaa2"]])

export default __exports__